class ClosingsActions {

  constructor() {
    this.generateActions(
      'readClosingsStatusSuccess', 'readClosingsStatusFail'
    );
  }

  readClosingsStatus() {
    return (dispatch, alt) =>
      alt.resolve(async () => {
        try {
          const response = await alt.request({ url: '/closings/status' });
          this.readClosingsStatusSuccess(response);
        } catch (error) {
          console.log(error);
          this.readClosingsStatusFail({ error });
        }
      });
  }

}

export default ClosingsActions;



// WEBPACK FOOTER //
// ./app/flux/actions/Closings.js